if (!customElements.get('af-hero-description')) {
  customElements.define('af-hero-description', class extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.af-cro-hero__text');
      this.button = this.querySelector('button');
      if (!this.text || !this.button) return;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.expanded = false;
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.update();
      };
      this.update = () => {
        const lineHeight = parseFloat(getComputedStyle(this.text).lineHeight);
        // Measure the full text without changing its rendered height.
        const range = document.createRange();
        range.selectNodeContents(this.text);
        const fullHeight = range.getBoundingClientRect().height;
        const collapsible = this.mobile.matches && fullHeight > lineHeight * 2 + 1;
        this.button.hidden = !collapsible;
        this.toggleAttribute('data-collapsed', collapsible && !this.expanded);
        this.button.setAttribute('aria-expanded', String(!collapsible || this.expanded));
        this.button.textContent = this.expanded
          ? this.button.dataset.collapseLabel
          : this.button.dataset.expandLabel;
      };
      this.button.addEventListener('click', this.toggle);
      this.mobile.addEventListener('change', this.update);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.text);
      this.update();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.mobile?.removeEventListener('change', this.update);
      this.observer?.disconnect();
    }
  });
}
